import {
	CARD_MIN_WIDTH,
	CAROUSEL_CARD_GAP_WIDTH,
	FOUR_CARDS_MIN_WIDTH,
	MAX_NUM_CARDS,
} from '../constants';

export const getNumCardsToShow = (width: number): number => {
	// Figure out if cards + gaps fit into the width
	const potentialNumCards = Math.floor(width / CARD_MIN_WIDTH);
	const numGaps = potentialNumCards - 1;
	const totalWidthOfPotentialCards =
		potentialNumCards * CARD_MIN_WIDTH + numGaps * CAROUSEL_CARD_GAP_WIDTH;

	// if max number of cards fit into the width, return max number of cards
	if (totalWidthOfPotentialCards > FOUR_CARDS_MIN_WIDTH) {
		return MAX_NUM_CARDS;
	}

	// if not, return the number of cards that fit into the width
	if (totalWidthOfPotentialCards > width) {
		return potentialNumCards - 1;
	} else {
		return potentialNumCards;
	}
};
